import Resource from 'components/global/Resource'
import SectionTitle from 'components/global/SectionTitle'
import { Col, Row, Section } from 'components/grid'
import OverlayVideo from 'components/overlay-video'
import { CoreAdoptionContext } from 'context/CoreAdoption'
import React, { useContext } from 'react'
import { formatSectionId } from 'components/core-adoption/functions/formatSectionId'

export default function ProfessionalLearning({ ...props }) {
	const { account, language } = useContext(CoreAdoptionContext)
	return (
		<Section margin="mt-20" id={formatSectionId(props)} className="scroll-mt-14">
			<SectionTitle
				title={language === 'english' ? 'Reimagine Professional Learning' : 'Reimaginar el aprendizaje profesional'}
				text={
					language === 'english'
						? 'True change requires more than a workshop. ARC provides the system in which adults get better every day. Professional learning is embedded in the tools teachers and leaders are using as they analyze data, plan and adjust instruction, and address systemic barriers to equity and excellence. As part of a comprehensive, continuous approach to improvement, the ARC team works side by side with teachers and leaders to establish the conditions for success, guide implementation, grow expertise, and change outcomes for all students.'
						: 'Los cambios duraderos requieren mucho más que un seminario de capacitación. ARC provee un sistema en el que los adultos mejoran sus habilidades a diario. El aprendizaje profesional viene integrado en las herramientas que los docentes y líderes utilizan mientras analizan datos, planifican y ajustan instrucción, y abordan barreras sistemáticas para la equidad y excelencia. Como parte de este enfoque de mejora continua y comprensiva, el equipo de ARC trabaja codo a codo con docentes y líderes para establecer las condiciones necesarias para lograr el éxito, dirigir la implementación, cultivar pericia y así cambiar los resultados para todos nuestros estudiantes.'
				}
			/>
			<Row center middle>
				{!account?.pl_videos.includes('The Impact of ARC Professional Learning') && (
					<Col width="w-full md:w-1/2" className="mb-6 md:mb-0">
						<OverlayVideo title="The Impact of ARC Professional Learning" />
					</Col>
				)}
				{!account?.pl_videos.includes('Leadership Learning Series Promo') && (
					<Col width="w-full md:w-1/2" className="mb-6 md:mb-0">
						<OverlayVideo title="Leadership Learning Series Promo" />
					</Col>
				)}
			</Row>
			<Row className="items-end justify-center py-20">
				{account?.pl_resources
					.filter((d) => d.active)
					.map((document) => {
						return (
							<Col key={document.name} width="w-1/2 sm:w-1/3 md:w-1/6 mb-6">
								<Resource logResourceView={{ type: 'resource' }} title={document.name} shadow text={document.text} />
							</Col>
						)
					})}
			</Row>
		</Section>
	)
}
